// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfileView_userProfile__hkDnN {
  margin: auto;
  max-width: 500px;
  padding: 20px;
}

.UserProfileView_title__TxwKB {
  margin-top: 40px;
  margin-bottom: 20px;
}

.UserProfileView_titleMin__gLsbw {
  margin-top: 40px;
  margin-bottom: 0;
}

.UserProfileView_inputContainer__obw\\+o {
  min-width: 220px;
  max-width: 220px;
}
.UserProfileView_inputContainer__obw\\+o input {
  text-align: left;
}

.UserProfileView_button__5A2Y9 {
  min-width: 220px;
  margin: 10px;
}

.UserProfileView_buttonContainer__FtPX8 {
  padding-top: 20px;
  padding-left: 0;
  padding-right: 20px;
}
@media (min-width: 320px) {
  .UserProfileView_buttonContainer__FtPX8 {
    padding-left: 20px;
  }
}
@media (min-width: 720px) {
  .UserProfileView_buttonContainer__FtPX8 {
    padding-left: 0;
  }
}

.UserProfileView_avatarContainer__J3EO1 {
  text-align: center;
}

.UserProfileView_avatar__GLRmJ {
  border-radius: 50%;
  width: 144px;
  height: 144px;
  border: 3px solid var(--accent-color);
}

.UserProfileView_subtitle__0ORxN {
  margin-top: 0;
  margin-left: 0;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/views/UserProfileView/UserProfileView.module.scss","webpack://./src/_common/scss/_media.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,YAAA;AAHF;;AAMA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AAHF;ACtBI;EDsBJ;IAMI,kBAAA;EAFF;AACF;ACnBI;EDcJ;IAUI,eAAA;EADF;AACF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;AADF;;AAIA;EACE,aAAA;EACA,cAAA;EACA,WAAA;AADF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_media';\n\n.userProfile {\n  margin: auto;\n  max-width: 500px;\n  padding: 20px;\n}\n\n.title {\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.titleMin {\n  margin-top: 40px;\n  margin-bottom: 0;\n}\n\n.inputContainer {\n  min-width: 220px;\n  max-width: 220px;\n\n  input {\n    text-align: left;\n  }\n}\n\n.button {\n  min-width: 220px;\n  margin: 10px;\n}\n\n.buttonContainer {\n  padding-top: 20px;\n  padding-left: 0;\n  padding-right: 20px;\n\n  @include media(xss) {\n    padding-left: 20px;\n  }\n\n  @include media(sm) {\n    padding-left: 0;\n  }\n}\n\n.avatarContainer {\n  text-align: center;\n}\n\n.avatar {\n  border-radius: 50%;\n  width: 144px;\n  height: 144px;\n  border: 3px solid $accent;\n}\n\n.subtitle {\n  margin-top: 0;\n  margin-left: 0;\n  color: #666;\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userProfile": `UserProfileView_userProfile__hkDnN`,
	"title": `UserProfileView_title__TxwKB`,
	"titleMin": `UserProfileView_titleMin__gLsbw`,
	"inputContainer": `UserProfileView_inputContainer__obw+o`,
	"button": `UserProfileView_button__5A2Y9`,
	"buttonContainer": `UserProfileView_buttonContainer__FtPX8`,
	"avatarContainer": `UserProfileView_avatarContainer__J3EO1`,
	"avatar": `UserProfileView_avatar__GLRmJ`,
	"subtitle": `UserProfileView_subtitle__0ORxN`
};
export default ___CSS_LOADER_EXPORT___;
